module.exports = __webpack_public_path__ + "img/cover.39ea7542.png";